

import React from 'react';
import {RobotWithCloudIcon} from '@communicare/medications/Components/Icons';
import styles from './ErrorAccessDenied.module.scss';

export const ErrorAccessDenied=()=>{
    return (
        <div className={styles.container}>
            <RobotWithCloudIcon />
            <div className={styles.left}>
                <div className={styles.text}>Whoops! Access denied.</div>
            </div>
            {/* {this.state.systemContactEmail && (
                <a href={email} target='_top' className={styles.action}>
                    CONTACT ADMINISTRATOR
                </a>
            )} */}
        </div>
    );
}